module.exports = __webpack_public_path__ + "static/media/dashboard-courses-performance.6e5bd6cb.svg";